const SCREEN_VARIANTS = {
  MOODBOARD: 'moodboard',
  IMG_DIRECTION: 'imgDirection'
}

export default SCREEN_VARIANTS
